<template>
  <v-card>
    <v-card-title style="height: 48px; flex-wrap: nowrap;">
      <v-layout class="userPreferencesHeader" row>
        <v-flex>
          <span class="userPreferencesName">User Preferences</span>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <v-btn xs icon @click.stop="cancel()">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-card-text style="height: calc(100vh - 210px);">
      <tree ref="tree" style="height: 100%;" :options="{ checkbox: true }" :data="locationNodes"></tree>
    </v-card-text>

    <v-divider />

    <v-card-actions>
      <v-spacer />
      <v-btn class="ntstAppButton" @click.stop="cancel() ">
        Cancel
      </v-btn>

      <v-btn class="ntstAppButton" @click.stop="save() ">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>

</template>


<script lang="js">

import Tree from 'liquor-tree';


export default {
  name: 'UserPreferences',
  data() {
    return {
    };
  },
  props: {
    onCancel: Function,
    onSave: Function
  },
  components: {
    tree: Tree
  },
  computed: {
    locationNodes() {
      return this.$store.getters.getLocationNodes();
    }
  },

  methods: {
    cancel() {
      this.onCancel();
    },

    save() {
      let unitIDs = [];

      // pull out ids that are selected
      const checkedNodes = this.$refs.tree.checked();
      if (checkedNodes) {
        unitIDs = checkedNodes.filter(node => node.data && node.data.id).map(node => node.data);
      }

      this.onSave(unitIDs);
    }
  }
};
</script>


<style lang="scss">
.tree-checkbox.checked {
  background-color: #003a5d;
  border-color: #003a5d;
}
.tree-checkbox.indeterminate {
  background-color: #39b54a;
  border-color: #003a5d;
}
.userPreferencesName {
  color: #39b54a;
  font-size: 14px;
  font-weight: 700;
}
</style>
